import Kavling1 from '../../Media/Kavling/Kavling (1).webp'
import Kavling2 from '../../Media/Kavling/Kavling (2).webp'


const Kavlingimages =[
Kavling1,Kavling2
]

export default Kavlingimages;